import React, { Component } from 'react';
import { connect } from 'react-redux';
import VideoThumbnail from "react-video-thumbnail";
import { Row, Col, Checkbox } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getCarousels, updateCarousels, getCarouselsSetting, updateCarouselsSetting, deleteCarousel } from '../../../actions/home';
import ArrowButton from '../../common/button-arrow';
import { Form, actions, Errors, Control } from 'react-redux-form';
import Spinner from '../../common/form/spinner';
import IgniteDataTable from '../../common/datatable';
import RangeSlider from '../../common/form/range-slider';
import ConfirmPopup from "../../common/confirm-popup";
import { history } from '../../../store';

import './style.css';

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      delete: {
        show: false
      }
    }
	}

  componentWillMount() {
    this.props.dispatch(getCarousels());
    this.props.dispatch(getCarouselsSetting());
  }

  handleDelete = (result) => {
    const id = this.state.delete.id;
    this.setState({delete: {show: false}});
    if(result) {
      this.props.dispatch(deleteCarousel(id));
    }
    var that = this;
    setTimeout(function(){
        that.props.dispatch(getCarousels());
      },100)
  };

  handleSliderChange(event) {
    const {value} = event;
    this.props.dispatch(actions.submitFields('deep.home_page_carousel_setting', updateCarouselsSetting(value)));
  }

  onSubmit = (payload) => {
    var NewPayload = {};
    NewPayload.position = [];
    NewPayload.live = [];
    for(var key in payload) {
      if(/^position_/.test(key)) {
        if (payload['live_' + key.match(/\d+/)[0]] == undefined) {
          NewPayload.live.push(false);
        }
        else {
          NewPayload.live.push(payload['live_' + key.match(/\d+/)[0]]);
        }
        NewPayload.position.push(payload[key]);
      }
    }
    this.props.dispatch(actions.submitFields('deep.home_page_carousel', updateCarousels(NewPayload)));
  };

  render() {
    var that = this;
    const columns = [
      {
        prop: 'position',
        title: 'Position',
        format(data, row) {
          return <Spinner model={'deep.home_page_carousel.position_' + row.id}
                          min={1}
                          max={that.props.carousels.length}
                          value={data}/>
        }
      },
      {
        prop:  'link',
        title: 'Thumbnail',
        format(data, row) {
          if(row.attributes['image-uid'].endsWith('.mp4')) {
            return <VideoThumbnail
              videoUrl={data.image}
            />
          } else {
            return <img src={data.image}
                        alt="carousel thumbnail"
                        className="imgPreview"/>
          }
        }
      },
      {prop: 'button-label', title: 'Button Text'},
      {
        prop: 'live', title: 'Live',
        format(data, row) {
          return <Control.checkbox component={Checkbox}
                                   model={`deep.home_page_carousel.live_${row.id}`}
                                   disabled={row.id == 1}
                                   defaultChecked={row.attributes.live ? true : undefined} />
        }
      },
    ];
    const actions = [
        {
          label: 'Edit',
          callback: (row) => {
            history.push(`/admin/homepage/carousel/${row.id}/edit`);
        }},
        {
          label: 'Delete',
          disabled: (row) => {
            return row.id == 1;
          },
          permissions: {
            action: "handle",
            subjectClass: "home_page",
          },
          callback: (row) => {
            this.setState({delete: {show: !this.state.delete.show, id: row.id}});
        }}
    ];
    return (
      <div>
				<Row>
          <Col md={12}>
            <h3>Carousel slide speed (seconds)</h3>
              <Form className="carousel-slider" model="deep.home_page_carousel_setting">
              {
              this.props.carousels_setting.attributes && <RangeSlider ignoreDynamicMeter labels={{start: 1, end: 32}} model="deep.home_page_carousel_setting.slide_speed" min={1} max={32} onChange={this.handleSliderChange.bind(this)}
                             value={this.props.carousels_setting.attributes['slide-speed']} unit=" "/>
              }
              </Form>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
          <Link to="/admin/homepage/carousel/new" className="add-carousel">
            <ArrowButton color="red" submit={false} arrow={false}>Add Slide</ArrowButton>
          </Link>
          </Col>
        </Row>

        {
          this.props.carousels_fetched &&
          <Row>
            <Col className="Carouselslist" md={12}>
              <Form model="deep.home_page_carousel" onSubmit={this.onSubmit}>
                <Errors className="errors" model="deep.home_page_carousel"/>
                <IgniteDataTable data={this.props.carousels}
                                 columns={columns}
                                 actions={actions}
                                 remote/>
                <Row>
                  <ArrowButton className="save-carousels" color="red">Save</ArrowButton>
                </Row>
              </Form>
            </Col>
          </Row>
        }

        {
          this.state.delete.show &&
          <ConfirmPopup header="DELETE CAROUSEL SLIDE?"
                        onClose={this.handleDelete}>
            <p>Are you sure you want to delete this carousel slide?</p>
          </ConfirmPopup>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    carousels_setting: state.home.home_carousels_setting,
    carousels:         state.home.home_carousels,
    carousels_fetched: state.home.carousels_fetched,
    fetching:          state.home.fetching,
    fetched:           state.home.fetched
  };
};

export default connect(mapStateToProps)(Carousel);



// WEBPACK FOOTER //
// ./src/components/admin/homepagemenu/carousel.jsx